import React from 'react';
import { clientUsage } from '../../../mocks/client';

/**
 * Usage meters (T9.5): plan allowance consumption for tasks and agent-hours.
 * Deliberately coarse — exact token accounting stays internal to the agency.
 */
function UsageMeter() {
  const rows = [
    {
      id: 'tasks',
      label: 'Tasks completed',
      used: clientUsage.usedTasks,
      included: clientUsage.includedTasks
    },
    {
      id: 'hours',
      label: 'Agent hours',
      used: clientUsage.usedAgentHours,
      included: clientUsage.includedAgentHours
    }
  ];

  return (
    <div className="portal-usage">
      <div className="portal-card-head">
        <div>
          <h2>Plan usage</h2>
          <span>{clientUsage.period} · included in your plan</span>
        </div>
      </div>
      {rows.map((row) => {
        const percent = Math.min(100, Math.round((row.used / row.included) * 100));
        return (
          <div className="portal-meter" key={row.id}>
            <div className="portal-meter-head">
              <span>{row.label}</span>
              <strong>{row.used.toLocaleString()} / {row.included.toLocaleString()}</strong>
            </div>
            <div
              aria-label={`${row.label}: ${percent}% of plan allowance used`}
              aria-valuemax={100}
              aria-valuemin={0}
              aria-valuenow={percent}
              className="portal-meter-track"
              role="progressbar"
            >
              <div className="portal-meter-fill" style={{ width: `${percent}%` }} />
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default UsageMeter;
